import React from "react";
import axios from "../../axios-atis";
import { lireFil, lienFil, marquerLu, rafraichirEtats } from "../../store/external/fil";
import "./EchangesClient.css";

// 04/11/2026 (registre n° 39) : bloc « Échanges avec le client » de la fiche (comptes ADMIN).
// Lecture : messages ATIS (Message laissé) + réponses du client en ligne, lus par le service Demandes reçues.
// Écriture : même chemin que « Appel fait » (POST /requests/{id}/call-done) + bouton « Répondre en ligne ».
const ECRITURE = [0, 7];

export default class EchangesClient extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fil: null, erreur: null, texte: "", envoi: false, info: null };
  }

  componentDidMount() {
    this.charger();
  }

  componentDidUpdate(prev) {
    const a = prev.request || {};
    const b = this.props.request || {};
    if (a.id !== b.id || a.status !== b.status) this.charger();
  }

  charger = () => {
    const r = this.props.request;
    if (!r || !r.id) return;
    lireFil(r.id)
      .then((fil) => this.setState({ fil, erreur: null }))
      .catch((e) => this.setState({ erreur: e.message || "indisponible" }));
  };

  lu = () => {
    marquerLu(this.props.request.id).then(this.charger).catch(() => {});
  };

  envoyer = () => {
    const r = this.props.request;
    const texte = this.state.texte.trim();
    if (!texte || this.state.envoi) return;
    const dest = this.contacts();
    if (!window.confirm("Envoyer ce message par mail à : " + (dest || "?") + " ?\nLa demande passera en « Message laissé ».")) return;
    const suite = this.state.fil && this.state.fil.messages.some((m) => m.de === "atis");
    this.setState({ envoi: true, info: null });
    lienFil(r.id)
      .then((j) => j.url)
      .catch(() => null)
      .then((replyUrl) => {
        const corps = { message: texte };
        if (replyUrl) corps.replyUrl = replyUrl;
        if (suite) corps.suite = "1";
        return axios.post("/requests/" + r.id + "/call-done", corps).then((resp) => ({ resp, replyUrl }));
      })
      .then(({ resp, replyUrl }) => {
        const d = resp && resp.data ? resp.data : {};
        let info;
        if (d.status !== 202) info = { ko: true, t: "Envoi refusé : " + (d.message || "erreur") };
        else if (d.message && d.message.indexOf("mail error") >= 0) info = { ko: true, t: "Message gardé, mais le mail n'est pas parti : " + d.message };
        else info = { ko: false, t: replyUrl ? "Message envoyé au client avec le bouton « Répondre en ligne »." : "Message envoyé (sans lien de réponse en ligne : service indisponible)." };
        this.setState({ envoi: false, texte: info.ko ? this.state.texte : "", info });
        rafraichirEtats();
        this.charger();
        if (this.props.onChange) this.props.onChange();
      })
      .catch(() => this.setState({ envoi: false, info: { ko: true, t: "Envoi impossible (erreur serveur)." } }));
  };

  contacts() {
    const r = this.props.request || {};
    return (r.contacts || []).map((c) => (typeof c === "string" ? c : c && c.email)).filter(Boolean).join(", ");
  }

  render() {
    const r = this.props.request;
    const { fil, erreur, texte, envoi, info } = this.state;
    if (!r) return null;
    if (erreur) return <div className="atis-echanges-erreur">Échanges client indisponibles ({erreur}).</div>;
    if (!fil) return null;
    const ecriture = ECRITURE.indexOf(r.status) >= 0 && fil.demande && fil.demande.ecriture;
    const msgs = fil.messages || [];
    if (!msgs.length && !ecriture) return null;
    const dest = this.contacts();
    return (
      <section className="atis-echanges" aria-label="Échanges avec le client">
        <div className="atis-echanges-tete">
          <span>Échanges avec le client</span>
          {fil.non_lus > 0 ? <span className="atis-echanges-nonlu">Réponse client · non lue</span> : null}
          <span className="atis-echanges-nb">{msgs.length} message{msgs.length > 1 ? "s" : ""}</span>
        </div>
        <div className="atis-echanges-corps">
          {msgs.length === 0 ? (
            <p className="atis-echanges-note">Aucun échange pour l'instant. Le 1er message part comme « Appel fait » (statut « Message laissé »).</p>
          ) : null}
          {msgs.map((m) => (
            <div key={m.id} className={"atis-msg " + (m.de === "client" ? "atis-msg-client" : "atis-msg-atis") + (m.non_lu ? " atis-msg-nonlu" : "")}>
              <div className="atis-msg-qui">
                <b>{m.de === "client" ? "Client · " + m.auteur : "ATIS · " + m.auteur}</b> · {m.le}
                {m.de === "atis" ? " · mail envoyé" : ""}
              </div>
              <div className="atis-msg-txt">{m.texte}</div>
              {m.pj && m.pj.length ? (
                <div className="atis-msg-pj">Pièces jointes : {m.pj.join(" ; ")} <small>(dans les pièces de la demande, en bas de page)</small></div>
              ) : null}
            </div>
          ))}
          {fil.non_lus > 0 ? (
            <div>
              <button type="button" className="atis-btn-sec" onClick={this.lu}>Marquer la réponse comme lue</button>
            </div>
          ) : null}
          {ecriture ? (
            <div className="atis-echanges-ecrire">
              <label htmlFor="atis-echanges-texte">Nouveau message au client</label>
              <textarea
                id="atis-echanges-texte"
                rows="4"
                value={texte}
                maxLength={4000}
                onChange={(e) => this.setState({ texte: e.target.value })}
              />
              <div className="atis-echanges-actions">
                <button type="button" className="atis-btn" disabled={envoi || !texte.trim() || !dest} onClick={this.envoyer}>
                  {envoi ? "Envoi…" : "Envoyer au client"}
                </button>
                {info ? <span className={info.ko ? "atis-echanges-ko" : "atis-echanges-ok"} role="status">{info.t}</span> : null}
              </div>
              <p className="atis-echanges-note">
                {dest
                  ? "Mail à " + dest + " (+ copie interventions), avec le bouton « Répondre en ligne ». Le message est gardé dans l'historique."
                  : "Aucun contact sur la demande : ajoutez un destinataire (Éditer la demande) pour pouvoir écrire au client."}
              </p>
            </div>
          ) : (
            <p className="atis-echanges-note">Écriture possible tant que la demande est « Envoyée » ou en « Message laissé ».</p>
          )}
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Request/EchangesClient.js